import { create } from 'zustand';

interface TypingState {
  typingUsers: Record<string, Record<string, { displayName: string; expiresAt: number }>>;

  setTyping: (channelId: string, userId: string, displayName: string) => void;
  clearTyping: (channelId: string, userId: string) => void;
  clearExpiredTyping: () => void;
  clearChannel: (channelId: string) => void;
  reset: () => void;
}

const initialState = {
  typingUsers: {} as Record<string, Record<string, { displayName: string; expiresAt: number }>>,
};

export const useTypingStore = create<TypingState>()((set) => ({
  ...initialState,

  setTyping: (channelId, userId, displayName) => set((s) => {
    const typingUsers = { ...s.typingUsers };
    const channelMap = { ...(typingUsers[channelId] ?? {}) };
    channelMap[userId] = { displayName, expiresAt: Date.now() + 3000 };
    typingUsers[channelId] = channelMap;
    return { typingUsers };
  }),

  clearTyping: (channelId, userId) => set((s) => {
    const channelMap = s.typingUsers[channelId];
    if (!channelMap?.[userId]) return s;
    const { [userId]: _sent, ...rest } = channelMap;
    const typingUsers = { ...s.typingUsers };
    if (Object.keys(rest).length === 0) delete typingUsers[channelId];
    else typingUsers[channelId] = rest;
    return { typingUsers };
  }),

  clearExpiredTyping: () => set((s) => {    const now = Date.now();
    let changed = false;
    const typingUsers = { ...s.typingUsers };
    for (const [channelId, userMap] of Object.entries(typingUsers)) {
      const filtered = { ...userMap };
      for (const [userId, info] of Object.entries(filtered)) {
        if (info.expiresAt < now) {
          delete filtered[userId];
          changed = true;
        }
      }
      if (Object.keys(filtered).length === 0) delete typingUsers[channelId];
      else typingUsers[channelId] = filtered;
    }
    return changed ? { typingUsers } : {};
  }),

  clearChannel: (channelId) => set((s) => {
    if (!s.typingUsers[channelId]) return s;
    const { [channelId]: _, ...rest } = s.typingUsers;
    return { typingUsers: rest };
  }),

  reset: () => set(initialState),
}));
